export default "__VITE_ASSET__cd417c59__"